<template>
	<div>
		<form method="POST" id="reg-form" class="pb-5 font-roboto-sans" @submit.prevent="submitRegistrationForm">
			<div class="row mt-4">

				<div class="col-lg-6 px-xl-5">
					<h2 class="fs-1-8 my-4">I tuoi dati</h2>

					<div class="row">
						<div class="col-12 form-group mb-2">
							<label for="nome">Il tuo nome*</label>
							<input type="text" name="nome" id="nome" class="form-control form-control-lg control-border-bottom" placeholder="Maria o Mario" required autocomplete="aut_off_iuasdsvkz" maxlength="150" v-model="form.name">
						</div>

						<div class="col-12 form-group mb-2">
							<label for="cognome">Il tuo cognome*</label>
							<input type="text" name="cognome" id="cognome" class="form-control form-control-lg control-border-bottom" placeholder="Rossi" required autocomplete="aut_off_iuasdsvkz" maxlength="150" v-model="form.lastname">
						</div>

						<div class="col-12 form-group mb-0 mb-1">
							<label for="e-mail">L’email con cui vuoi registrarti*</label>
							<input type="email" name="e-mail" id="e-mail" class="form-control form-control-lg control-border-bottom mb-0" placeholder="Riceverai notizie sul progetto" required  autocomplete="aut_off_iuasdsvkz" maxlength="150" v-model="form.email">
						</div>
						<div class="col-12 text-left mb-2" style="line-height:0.7;">
							<small class="mb-0 fs-0-7">Questa email ti servirà per accedere alla tua area riservata.</small>
						</div>

						<div class="col-12 form-group mb-2">
							<label for="tel">Il tuo numero di cellulare*</label>
							<input type="text" name="tel" id="tel" class="form-control form-control-lg control-border-bottom" placeholder="Per info rapide o vittoria" required autocomplete="aut_off_iuasdsvkz" maxlength="100" v-model="form.tel">
						</div>

						<div class="col-12 form-group input-group input-group-lg mb-2">
							<label for="referente" class="d-block w-100">Hai saputo del progetto grazie a*</label>
							<select id="referente" name="referente" class="form-select form-select-lg custom-select d-block rounded-pill" required v-model="form.referente">
								<option value="" class="placeholder">SCEGLI UN'OPZIONE</option>
								<option value="UNA TELEFONATA INFORMATIVA">UNA TELEFONATA INFORMATIVA</option>
								<option value="UNA EMAIL INFORMATIVA">UNA EMAIL INFORMATIVA</option>
								<option value="CANALI SOCIAL">CANALI SOCIAL</option>
								<option value="COLLEGA">UN/A COLLEGA</option>
								<option value="PIATTAFORMA DOCENTIEFORMAZIONE.IT">PIATTAFORMA DOCENTIEFORMAZIONE.IT</option>
								<option value="SUGGERIMENTO DI UN GENITORE">SUGGERIMENTO DI UN GENITORE</option>
							</select>
						</div>

						<div class="col-12 form-group mb-2 text-end">
							<span class="fs-0-8">* Campi obbligatori</span>
						</div>
					</div>
				</div>

				<div class="col-lg-6 px-xl-5">
					<h2 class="fs-1-8 mt-4">I dati della scuola</h2>
					<p class="mb-4">Cerca il nome del plesso (NON quello dell’Istituto Comprensivo).</p>

					<div class="row"> <!-- Disaled for this site-->
						<div class="col-12 form-group mb-4 input-group input-group-lg">
							<select name="grado-filter" id="grado-filter" class="form-select form-select-lg custom-select" v-model="selected.grado" @change="populateRegionSelect" required>
								<option value=""><span class="color-blue-light">PRIMARIA O SECONDARIA I GRADO*</span></option>
								<option value="2">SCUOLA PRIMARIA</option>
								<option value="1">SCUOLA SECONDARIA I GRADO</option>
							</select>
						</div>
					</div>

					<div class="row">
						<div class="col-12 form-group mb-4 input-group input-group-lg">
							<select name="regio-filter" id="regio-filter" class="form-select form-select-lg custom-select" v-model="selected.region" @change="populateProvinceSelect" required>
								<option value=""><span class="color-blue-light">REGIONE*</span></option>
								<option :value="region.regione" v-for="(region, index) in selects.regions" :key="index">{{region.regione}}</option>
							</select>
						</div>

						<div class="col-12 form-group mb-4 input-group input-group-lg">
							<select name="prov-filter" id="prov-filter" class="form-select form-select-lgcustom-select" v-model="selected.province" @change="populateCitiesSelect" required>
								<option value="">PROVINCIA*</option>
								<option :value="province.provincia" v-for="(province, index) in selects.provinces" :key="index">{{province.provincia}}</option>
							</select>
						</div>

						<div class="col-12 form-group mb-4 input-group input-group-lg">
							<select name="com-filter" id="com-filter" class="form-select form-select-lg custom-select" v-model="selected.city" @change="populateSchoolSelect" required>
								<option value="">COMUNE*</option>
								<option :value="city.citta" v-for="(city, index) in selects.cities" :key="index">{{city.citta}}</option>
							</select>
						</div>

						<div class="col-12 form-group input-group input-group-lg mb-1">
							<select name="school-filter" id="school-filter" class="form-select form-select-lg custom-select" v-model="selected.school" @change="showSelectedSchool" required>
								<option value="">SELEZIONA LA TUA SCUOLA*</option>
								<option :value="school.IDist" v-for="(school, index) in selects.schools" :key="index">{{school.nome}}</option>
							</select>
						</div>

						<div class="col-12 mb-3" v-if="showNotify">
							<div class="pb-1">
								<small class="fs-0-8"><i>Non trovi il nome della tua scuola? <a href="#" @click.prevent="showEmailModal" class="bold underline">Segnalacelo qui</a></i></small>
							</div>
						</div>
					</div>

					<div class="row m-0">
						<div class="col-12" v-if="Object.keys(showingSchool).length != 0"><small class="bold fs-0-8">Scuola selezionata</small></div>
						<div class="col-12 form-group mb-3 rounded py-2" v-if="Object.keys(showingSchool).length != 0" style="background-color: #dddddd;">
							<div class="py-2 fs-0-8 bold">
								Scuola: {{showingSchool.nome}}<br>
								Città: {{showingSchool.citta}}<br>
								Indirizzo: {{showingSchool.indirizzo}}
							</div>
						</div>
					</div>
				</div>

				<div id="add-cls" class="col-lg-6 offset-lg-6 px-xl-5" v-if="schoolIsVisible">
					<div class="pt-2 pb-3">
						<div class="row align-items-center">
							<div class="col-12 mb-0"><span class="">Aggiungi una o più classi*</span></div>
							<div class="col-md-3 form-group mb-3 input-group-lg mt-2">
								<select name="classi" id="classi" class="form-select form-select-lg custom-select" v-model="selected.class" @change="msg.clsError = ''">
									<option :value="value.no" v-for="(value, index) in classes.slice(0, limitClasses)" :key="index">{{value.class}}</option>
								</select>
							</div>

							<div class="col-md-3 form-group mb-3 input-group-lg mt-2">
								<select name="sezioni" id="sezioni" class="form-select form-select-lg custom-select" v-model="selected.classLetter" @change="msg.clsError = ''">
									<option value="A">A</option>
									<option value="B">B</option>
									<option value="C">C</option>
									<option value="D">D</option>
									<option value="E">E</option>
									<option value="F">F</option>
									<option value="G">G</option>
									<option value="H">H</option>
									<option value="I">I</option>
									<option value="J">J</option>
									<option value="K">K</option>
									<option value="L">L</option>
									<option value="M">M</option>
									<option value="N">N</option>
									<option value="O">O</option>
									<option value="P">P</option>
									<option value="Q">Q</option>
									<option value="R">R</option>
									<option value="S">S</option>
									<option value="T">T</option>
									<option value="U">U</option>
									<option value="V">V</option>
									<option value="W">W</option>
									<option value="X">X</option>
									<option value="Y">Y</option>
									<option value="Z">Z</option>
								</select>
							</div>

							<div class="col-md-5 form-group mb-3 input-group-lg text-start mt-2">
								<button role="button" type="button" id="btn-add-cls" class="btn btn-secondary btn-lg rounded-pill px-3 py-2" @click.prevent="addSelectdClass">
									<span class="fs-1">Aggiungi classe</span>
								</button>
							</div>

							<div class="col-12">
								<small class="red-text">{{msg.clsError}}</small>
							</div>

						</div>

						<div class="row" v-if="selectedClassesList.length > 0">
							<div class="col-12">
								<div class="row">
									<div class="col-12 mb-1"><small class="bold">Classi aggiunte</small></div>

									<div class="col-12 class-row" v-for="(cls, index) in selectedClassesList" :key="index">
										<div class="class-row-item mb-3">
											<div class="row align-items-center">
												<div class="col-9 pe-0">
													<div class="fs-1-3 bold text-green-2" style="border-bottom:1px solid #22733e;">
														<span class="mr-3 ">{{cls.class}}</span> <span>{{cls.letter}}</span>
													</div>
												</div>
												<div class="col text-end ps-0">
													<div class="fs-1-3 bold" style="border-bottom:1px solid #22733e;">
														<i class="fas fa-times va-m me-1 text-green-2" @click.prevent="removeClass(index)"></i>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>

					</div>
				</div>

				<div class="col-lg-6 offset-lg-6 px-xl-5 d-school d-school-none">
					<div class="row">
						<div class="col-12 form-group mb-2 custom-form-check mt-2">
							<input id="prvc-info" class="checkbox-custom" name="prvc" type="checkbox" required v-model="form.privacyInfo">
							<label for="prvc-info" class="checkbox-custom-label fs-0-7">
								<span class="lh-1-3">*Ho letto e accetto il <a :href="pdfRegulation" target="_blank" class="bold underline">Regolamento</a></span>
							</label>
						</div>
					</div>
				</div>

				<div class="col-lg-6 offset-lg-6 px-xl-5 d-school d-school-none">
					<div class="row">
						<div class="col-12 form-group mb-2 custom-form-check mt-2">
							<input id="prvc" class="checkbox-custom" name="prvc" type="checkbox" required v-model="form.privacy">
							<label for="prvc" class="checkbox-custom-label fs-0-7">
								<span class="lh-1-3">*Ho preso visione dell’<a :href="pdfPrivacy" target="_blank" class="bold underline">Informativa Privacy</a> e acconsento al trattamento dei miei dati personali</span>
							</label>
						</div>
					</div>
				</div>

				<div class="col-lg-6 offset-lg-6 px-xl-5 d-school d-school-none my-2">
					<double-exlusive-checkbox
						:key="2348126347"
						htmlText=""
						:htmlError="defPrivacyError"
						:reset="resetDefPrivacy"
						id-el-no="chk-no"
						id-el-yes="chk-yes"
						@sendValues="setPrivacyDef"
					>
						<p class="fs-0-7 mb-1 lh-1-3">
							Fornisco il consenso a ricevere informazioni su progetti gratuiti per le scuole e formazione per docenti e dichiaro di aver preso visione dell’<a :href="pdfPrivacy" class="underline" target="_blank">informativa</a> nel punto B) e dichiaro di avere compiuto almeno 16 anni.
						</p>
					</double-exlusive-checkbox>
				</div>

				<div class="col-lg-6 offset-lg-6 px-xl-5 mt-4 mb-3 d-school d-school-none">
					<button type="submit" id="sub-teach" class="btn btn-green rounded-pill px-4 py-2" value="INVIA" :disabled="form.showLoader"><span>CONFERMA E REGISTRATI</span>  <i class="fas fa-circle-notch fa-spin ms-1 lh-1-2" :class="{'d-none': !form.showLoader}"></i></button>
				</div>
			</div>
		</form>

		<modal name="school-add"
			height="auto"
			:adaptive=true
		> <!-- ** Modal ************************* -->
			<div class="p-3">
				<form id="email-form" @submit.prevent="submitSchoolNotify">
					<div class="container">
						<div class="row">
							<div class="col-12 text-end pe-0"><i class="fas fa-times hover-default text-green fs-2-2" @click.prevent="hideEmailModal"></i></div>
						</div>
						<div class="row">
							<div class="col-12 mb-3"><h5>Segnalaci la tua scuola</h5></div>
							<div class="col-12 form-group mb-3">
								<input type="text" name="nome-cognome" id="nome-cognome" class="form-control form-control-lg" placeholder="Nome e/o Cognome*" required autocomplete="aut_off_iuasdsvkz" maxlength="150" v-model="emailForm.namelastname">
							</div>
							<div class="col-12 form-group mb-3">
								<input type="email" name="email-notify" id="email-notify" class="form-control form-control-lg" placeholder="Latua email*" required autocomplete="aut_off_iuasdsvkz" maxlength="150" v-model="emailForm.email">
							</div>
							<div class="col-12 form-group mb-3">
								<input type="text" name="nome-scuola" id="nome-scuola" class="form-control form-control-lg" placeholder="Nome scuola*" required autocomplete="aut_off_iuasdsvkz" maxlength="150" v-model="emailForm.name">
							</div>
							<div class="col-12 form-group mb-3">
								<input type="text" name="citta-scuola" id="citta-scuola" class="form-control form-control-lg" placeholder="Comune scuola*" required autocomplete="aut_off_iuasdsvkz" maxlength="150" v-model="emailForm.city">
							</div>
							<div class="col-12 form-group mb-3">
								<input type="text" name="mec-cod" id="mec-cod" class="form-control form-control-lg" placeholder="Codice meccanografico" autocomplete="aut_off_iuasdsvkz" maxlength="150" v-model="emailForm.mecCod">
							</div>
							<div class="col-12 my-1" v-if="emailForm.msgModalForm">
								<div class="text-center" v-html="emailForm.msgModalForm"></div>
							</div>
							<div class="col-lg-6 offset-lg-6 text-end mt-2 mb-3">
								<button type="submit" id="sub-notify" class="btn btn-green btn-lg px-5" value="INVIA" :disabled="emailForm.showLoaderModal"><span>Invia</span> <i class="fas fa-circle-notch fa-spin lh-1-2 ms-1" :class="{'d-none': !emailForm.showLoaderModal}"></i></button>
							</div>
						</div>
					</div>
				</form>
			</div>
		</modal>

		<!-- Modal Confirm -->
		<modal name="thanks"
			height="auto"
			:adaptive=true
		>
			<div class="container text-center" style="background-color: #fff;">
				<div class="row lh-1">
					<div class="col-12 text-end px-0 pt-2">
						<i class="fas fa-times hover-default fs-2" @click.prevent="hideEmailModalThanks"></i>
					</div>
				</div>
				<div class="row">
					<div class="col-12">
						<div class="px-3 pb-3 pt-0 fs-1-3 mb-3 text-center" v-html="msg.msgForm"></div>
					</div>
				</div>
			</div>
		</modal>

	</div>
</template>

<script>
import axios from 'axios'
import DoubleExlusiveCheckbox from './DoubleExlusiveCheckbox.vue'

export default {
	props: ['pdfPrivacy', 'pdfRegulation', 'themeUrl'],
	components: {DoubleExlusiveCheckbox},

	data() {
		return {
			ajaxObj: window.ajax_object,
			selects: {
				regions: {},
				provinces: {},
				cities: {},
				schools: {}
			},
			selected: {
				grado: '',
				region: '',
				province: '',
				city: '',
				class: '1',
				classLetter: 'A',
				school: ''
			},
			form: {
				name: '',
				lastname: '',
				email: '',
				tel: '',
				materia: '',
				referente: '',
				privacy: false,
				privacyInfo: false,
				privacyDef: '',
				showLoader: false
			},
			defPrivacyError: '',
			resetDefPrivacy: false,
			selectedClassesList: [],
			showingSchool: {},
			classes: [
				{
					class: '1',
					no: 1
				},
				{
					class: '2',
					no:2
				},
				{
					class: '3',
					no:3
				},
				{
					class: '4',
					no: 4
				},
				{
					class: '5',
					no: 5
				}
			],
			limitClasses: 0,
			schoolIsVisible: false,
			msg: {
				clsError: '',
				msgForm: ''
			},
			showSubType: false,
			schoolIsSelected: false,
			showNotify: false,
			emailForm: {
				name: '',
				mecCod: '',
				city: '',
				email: '',
				namelastname: '',
				showLoaderModal: false,
				msgModalForm: ''
			}
		}
	},

	watch: {
		'selects.schools': function (newObi) {
			if(Object.keys(newObi).length == 0) {
				this.selectedClassesList = []
				this.showingSchool = {}
			}
		},
		'selected.school': function() {
			this.selectedClassesList = []
		}
	},

	methods: {
		populateRegionSelect() {
			this.showSubType = this.selected.grado == '2' ? true : false
			this.selects.regions = {}
			this.selects.cities = {}
			this.selects.provinces = {}
			this.selects.schools = {}
			this.selected.region = ''
			if(this.selected.grado != '') {
				this.limitClasses = (this.selected.grado == 1) ? 3 : 5

				let url = this.ajaxObj.ajax_url
				var data = new FormData();
				data.append('action', 'nl_pop_reg')
				data.append('_nounce_value', this.ajaxObj._nounce_value)
				data.append('grado', this.selected.grado)

				axios.post(url, data)
					.then((response) => {
						// console.log(response.data)
						this.selects.regions = response.data
						this.selected.province = ''
						this.selected.city = ''
						this.selected.class = '1'
						this.selected.school = ''
						this.schoolIsVisible = false
					}, (error) => {
						console.log(error);
						this.selected.region = ''
						this.selected.province = ''
						this.selected.city = ''
						this.schoolIsVisible = false
					});
			} else {
				this.selected.region = ''
				this.selected.province = ''
				this.selected.city = ''
				this.selected.class = '1'
				this.selected.school = ''
				this.schoolIsVisible = false
				this.limitClasses = 0
			}
		},
		populateProvinceSelect() {
			this.selects.cities = {}
			this.selects.schools = {}
			if(this.selected.region != '') {
				let url = this.ajaxObj.ajax_url
				var data = new FormData();
				data.append('action', 'nl_pop_prov')
				data.append('_nounce_value', this.ajaxObj._nounce_value)
				data.append('region', this.selected.region)
				data.append('grado', this.selected.grado)

				axios.post(url, data)
					.then((response) => {
						this.selects.provinces = response.data
						this.selected.province = ''
						this.selected.city = ''
						this.selected.school = ''
						this.schoolIsVisible = false
					}, (error) => {
						console.log(error);
					});
			} else {
				this.selected.province = ''
				this.selected.city = ''
				this.selected.school = ''
				this.schoolIsVisible = false
				this.selects.provinces = {}
				this.selects.cities = {}
				this.selects.schools = {}
			}
		},
		populateCitiesSelect() {
			this.selects.schools = {}
			if(this.selected.province != '') {
				let url = this.ajaxObj.ajax_url
				var data = new FormData();
				data.append('action', 'nl_pop_com')
				data.append('_nounce_value', this.ajaxObj._nounce_value)
				data.append('province', this.selected.province)
				data.append('grado', this.selected.grado)

				axios.post(url, data)
					.then((response) => {
						this.selects.cities = response.data
						this.selected.city = ''
						this.selected.school = ''
						this.schoolIsVisible = false
					}, (error) => {
						console.log(error);
					});
			} else {
				this.selected.city = ''
				this.selected.school = ''
				this.schoolIsVisible = false
				this.selects.cities = {}
				this.selects.schools = {}
			}
		},
		populateSchoolSelect() {
			this.showingSchool = {}
			if(this.selected.city != '') {
				this.showNotify = true
				let url = this.ajaxObj.ajax_url
				var data = new FormData();
				data.append('action', 'nl_get_schools')
				data.append('_nounce_value', this.ajaxObj._nounce_value)
				data.append('city', this.selected.city)
				data.append('grado', this.selected.grado)

				axios.post(url, data)
					.then((response) => {
						this.selects.schools = response.data
						this.selected.school = ''
						this.schoolIsVisible = false
					}, (error) => {
						console.log(error);
					});
			} else {
				this.showNotify = false
				this.selected.school = ''
				this.selects.schools = {}
				this.schoolIsVisible = false
			}
		},
		showSelectedSchool() {
			if(this.selected.school != '') {
				this.schoolIsSelected = true
				this.showingSchool = this.selects.schools.find(obj => {
					return obj.IDist === this.selected.school
				})

				this.schoolIsVisible = true
			} else {
				this.schoolIsSelected = false
				this.showingSchool = {}
				this.schoolIsVisible = false
			}

		},
		addSelectdClass() {
			this.msg.clsError = ''
			let arrayRow = {
				class: this.selected.class,
				letter: this.selected.classLetter
			}
			const rowExists = this.selectedClassesList.some(x => x.class === this.selected.class && x.letter === this.selected.classLetter)
			if (rowExists) {
				this.msg.clsError = 'Attenzione: hai già inserito questa classe!'
			} else {
				this.selectedClassesList.push(arrayRow)
			}
		},
		removeClass(index) {
			let arr = this.selectedClassesList;
			arr.splice(index, 1);
			this.selectedClassesList = arr;
			this.msg.clsError = ''
		},

		submitRegistrationForm() {
			let url = this.ajaxObj.ajax_url
			this.msgForm = ''
			this.form.showLoader = true

			if(this.form.privacyDef != '') {

				var data = new FormData();
				data.append('action', 'nl_submit_school')
				data.append('_nounce_value', this.ajaxObj._nounce_value)
				data.append('nome', this.form.name)
				data.append('cognome', this.form.lastname)
				data.append('email', this.form.email)
				data.append('tel', this.form.tel)
				data.append('privacy', this.form.privacy)
				data.append('materia', this.form.materia)
				data.append('selected_school', this.selected.school)
				data.append('selected_classes', JSON.stringify(this.selectedClassesList))
				data.append('provincia', this.selected.province)
				data.append('citta', this.selected.city)
				data.append('referente', this.form.referente)
				data.append('privacy_def', this.form.privacyDef)
				data.append('school_type', this.selected.grado)

				axios.post(url, data)
					.then((response) => {
						// console.log(response.data)
						if(response.data.error == '') {
							this.resetForm()
							this.msg.msgForm = response.data.msg
							this.$modal.show('thanks')
						} else {
							this.msg.msgForm = response.data.error
							this.$modal.show('thanks')
						}
						this.form.showLoader = false
					}, (error) => {
						console.log(error);
						this.form.showLoader = false
					})
			} else {
				if(this.form.privacyDef == '') {
					this.defPrivacyError = '<p class="fs-0-7 lh-1-25 text-red">Scegliere se ricevere informazioni su progetti gratuiti per le scuole e formazione per docenti.</p>'
					this.form.showLoader = false
				}
			}
		},
		resetForm() {
			this.selects = {
				regions: {},
				provinces: {},
				cities: {},
				schools: {}
			}
			this.selected = {
				grado: '',
				region: '',
				province: '',
				city: '',
				class: '1',
				classLetter: 'A',
				school: ''
			}
			this.form = {
				name: '',
				lastname: '',
				email: '',
				tel: '',
				materia: '',
				privacy: false
			}
			this.selectedClassesList = []
			this.showingSchool = {}
			this.limitClasses = 0
			this.schoolIsVisible = false
			this.msg = {
				clsError: ''
			}
			this.showNotify = false
			this.showSubType = false
			this.schoolIsSelected = false
			this.resetDefPrivacy = true
			window.scrollTo(0, document.body.scrollHeight || document.documentElement.scrollHeight);
		},

		showEmailModal () {
			this.emailForm.email = this.form.email
            this.$modal.show('school-add');
        },

		hideEmailModal() {
			this.emailForm = {
				name: '',
				mecCod: '',
				city: '',
				namelastname: ''
			}
			this.$modal.hide('school-add');
		},

		submitSchoolNotify() {
			let url = this.ajaxObj.ajax_url

			this.emailForm.msgModalForm = ''
			this.emailForm.showLoaderModal = true

			var data = new FormData();
			data.append('action', 'nl_new_school_notify')
			data.append('_nounce_value', this.ajaxObj._nounce_value)
			data.append('nome', this.emailForm.namelastname)
			data.append('email', this.emailForm.email)
			data.append('city', this.emailForm.city)
			data.append('mec_cod', this.emailForm.mecCod)
			data.append('school_name', this.emailForm.name)

			axios.post(url, data)
				.then((response) => {
					// console.log(response.data)
					this.emailForm.showLoaderModal = false
					if(response.data.error == '') {
						this.emailForm.msgModalForm = response.data.msg

						this.emailForm.namelastname = ''
						this.emailForm.email = ''
						this.emailForm.city = ''
						this.emailForm.mecCod = ''
						this.emailForm.name = ''
					} else {
						this.emailForm.msgModalForm = response.data.error
					}
				}, (error) => {
					this.emailForm.showLoaderModal = false
					console.log(error);
				});
		},

		hideEmailModalThanks() {
			this.$modal.hide('thanks')
		},

		setPrivacyDef(choice) {
			this.resetDefPrivacy = false
			if(choice.checkY) {
				this.form.privacyDef = 'yes'
			} else if(choice.checkN) {
				this.form.privacyDef = 'no'
			} else {
				this.form.privacyDef = ''
			}
			this.defPrivacyError = ''
		}
	}
}
</script>

<style scoped>
.fas.fa-times {cursor: pointer !important;}
input, select {
	border-radius: 50rem !important;
	border: 2px solid #9AC10C !important;
}
</style>
